import { defineComponent as o, createBlock as n, openBlock as p, normalizeProps as a, guardReactiveProps as l, withCtx as s, renderSlot as m, createElementVNode as d } from "vue";
import i from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ o({
  name: "Star100",
  __name: "star-100",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (r, e) => (p(), n(i, a(l(t.props)), {
      default: s(() => [m(r.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M5.686 22.066l1.668-7.552L1.82 9.465l7.298-.659 2.877-7.146 2.877 7.146 7.298.659-5.534 5.049 1.668 7.552-6.309-4.006z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
